import X from "../src/assets/img/UI/x.png";
import Dribble from "../src/assets/img/UI/dribble.png";
import Be from "../src/assets/img/UI/Be.png";

const teamProfile = [
  {
    id: 1,
    name: "Ibironke Johnson",
    role: "Managing Director",
    intro:
      "FOUNDER & CEO, CEPHAS ICT HUB. || Digital Transformation || Sustainable Development || Training & Capacity Building || Talent Outsourcing || Community Impact and Transformation.",
    yearsExperience: "8",
    projectsCompleted: "20",
    image: "Mr Johnson.jpg",
    bio: `Johnson is recognized as the founder of Cephas ICT HUB, an organization through which ICT training has been facilitated for over 2,000 students at several universities as part of a skill acquisition and empowerment drive for capacity building. His experience is rooted in software design and development.`,

    bio2: `As a consultant, the development of clients' software projects in West and Central Africa has been overseen by Johnson. A proven track record of leading technology teams and driving innovation in fast-paced, dynamic environments has been established in his role as chief technology officer. 

With over six years of experience, technology strategies have been shaped, infrastructure optimized, and cutting-edge solutions delivered under his leadership. Technology initiatives have been aligned with business goals, cross-functional collaboration fostered, and digital transformation initiatives executed successfully.  

With a strong passion and expertise in software engineering, cybersecurity, IoT, AI, mobile app development,  
and IT trainings, Johnson is known for developing and implementing strategic roadmaps, driving product development,  
staying at the forefront of emerging technologies, and leveraging them to maintain a competitive edge in the industry  
for operational efficiency.  

`,
    skills: [
      "Product Management",
      "Community Development",
      "Software Development",
      "Large Scale Projects ",
      "Database Administration",
      " Mobile Application Development",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    education: [
      {
        degree: "MSc Computer Science",
        institution: "Ajayi Crowther University",
        // period: "2011-2015",
      },

      {
        degree: "Bachelor's Degree, Chemical Enginering",
        institution: "Ladoke Akintola University Of Technology",
        // period: "2010-2016",
      },
    ],

    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
  },

  {
    id: 2,
    name: "Olawale Michael",
    role: "Software Engineer (Backend)",
    intro:
      "As a Research Associate and Software Engineer at Cephas ICT HUB, Michael leverage his expertise in software development and research to drive innovation and excellence.",
    yearsExperience: "6",
    projectsCompleted: "13",
    image: "micheal.jpg",
    bio: `Michael is recognized for his passion for building innovative solutions that bridge the gap between humans and their systems.

Over half a decade of experience has been gathered by him in computer science, software development, human-computer interaction, and the Internet of Things, resulting in solutions being developed for various problems in these fields.

A strong drive for innovation has been reflected in the high value he places on learning, researching, brainstorming, and exploring novel ideas, which are regarded as essential tools for building impactful solutions.

The same passion has fueled his eagerness to assist firms and businesses in transforming their technical ideas or innovations into reality.

Research is currently being conducted by him to address the long-standing practical problem of program quality assurance.

Interest is also held by him in exploring new ideas and collaborations that advance impactful concepts—connections are welcomed to help move such ideas forward.`,

    skills: [
      "R&D Planning",
      "Collaborative R&D",
      "Web Development",
      "Web Application,",
      " Javascript",
      "Semantic HTML",
      "SQL",
      "Node.js",
      "React.js",
      "Firebase",
      "Cloud Firestore",
      " MongoDB",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Technical Research", percentage: 100 },
      { name: "Product Research", percentage: 90 },
      { name: "Innovation & Development", percentage: 85 },
      { name: "Software Development", percentage: 88 },
    ],
    education: [
      {
        degree: "Bachelor's degree, Computer Science",
        institution: "University of London",
        // period: "Oct 2020 -Sept 2024",
      },
      {
        degree: "Bachelor Of Technology, Food Engineering",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2017-Aug 2023",
      },
    ],
    // socialLinks: [
    //   { platform: "LinkedIn", url: "#", icon: "linkedin.png" },
    //   { platform: "Twitter", url: "#", icon: "twitter" },
    //   { platform: "Reddit", url: "#", icon: "reddit" },
    //   { platform: "Behance", url: "#", icon: "behance" },
    // ],
  },

  {
    id: 3,
    name: "Idowu Felix",
    role: "Software Engineer (Mobile)",
    intro: "Mobile Engineer || Projects manager || Bioinformatics Enthusiast",
    yearsExperience: "6",
    projectsCompleted: "12",
    image: "felix.jpg",
    bio: `Felix has been recognized as an experienced React Native Developer with a strong foundation in TypeScript and JavaScript, adept at creating high-performance, cross-platform mobile applications for both iOS and Android. By leveraging a unique blend of biochemistry, bioinformatics, and business acumen, an interdisciplinary approach has been brought by him to the delivery of innovative mobile solutions.

A proven track record has been established by him through the building and deployment of over 5 mobile applications on the Google Play Store within the tech industry. Analytical skills, honed through his scientific training, have ensured a methodical and data-driven approach to development, resulting in scalable and user-friendly mobile solutions that drive business growth.

In addition to technical expertise, significant experience in business, project management, and leadership has been possessed by Felix. Strategic insight and the ability to drive project success while fostering a collaborative team environment have been consistently demonstrated.

A commitment to continuous learning and staying abreast of emerging technologies has made him a versatile and valuable asset to any development team.`,

    skills: [
      "Software design",
      "Mobile app development",
      "Team collaboration",
      "Project planning",
      "Certified Google AI essential",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Technical Research", percentage: 95 },
      { name: "Product Research", percentage: 90 },
      { name: "Innovation & Development", percentage: 85 },
      { name: "Software Development", percentage: 88 },
    ],
    education: [
      {
        degree: "Bachelor Of Applied Science in BioChemistry",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2018-Aug 2023",
      },
    ],
  },
  {
    id: 4,
    name: "Adaralegbe Ifeoluwa",
    role: "Software Engineer (Web)",
    intro: `FullStack Developer
    Back End Developer at Cephas Digital Technology`,
    yearsExperience: "6",
    projectsCompleted: "15",
    image: "ifeoluwa.jpg",
    bio: `Ifeoluwa is a seasoned Fullstack Developer with a robust background in crafting dynamic web solutions. Expertise has been gained by him in key areas, including database integration, RESTful API design and implementation, authentication and authorization, frontend integration, and server-side rendering. He is also well-versed in agile development methodologies and has experience collaborating with cross-functional teams to deliver successful projects.

Skills are held by him in NodeJS, TypeScript, MongoDB, HTML, CSS, Bootstrap, TailwindCSS, JavaScript, GitHub, ExpressJS, and ReactJS.

He is a graduate of Ladoke Akintola University, Ogbomosho, Oyo State.`,

    skills: [
      "NodeJS",
      "Typescript",
      "MongoDB",
      "HTML-CSS-Bootstrap",
      "TailwindCSS",
      "JavaScript",
      "GitHub",
      "ExpressJS",
      "ReactJS",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Technical Research", percentage: 95 },
      { name: "Product Research", percentage: 90 },
      { name: "Innovation & Development", percentage: 85 },
      { name: "Software Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B.Tech Computer Science and Engineering",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "2015-2021",
      },
    ],
  },

  {
    id: 5,
    name: "Olajide Ayomide",
    role: "Software Engineer (Web)",
    intro: "Software Engineer | Devops Engineer | Datacom Enthusiast",
    yearsExperience: "6",
    projectsCompleted: "10",
    image: "ayomide.jpg",
    bio: `Ayomide is recognized as a complex problem-solver with an analytical and driven mindset. High-demand development objectives are pursued by him according to tight schedules while impeccable code is produced.

Strong organizational skills and the ability to handle multiple projects simultaneously with a high degree of accuracy are demonstrated by him as a detail-oriented team player.

Reliable solutions for software issues are consistently found by him as a respectful self-motivator.

Experience in React and Node.js is possessed by him, with skills offered in both Frontend and Backend development.

Fluency in English is held by him, and experience in working with cross-cultural, global teams has been gained.`,

    skills: [
      "Frontend Development: React.js, Next.js, TypeScript, JavaScript (ES6+)",
      "Tailwind CSS: Tailwind CSS, Chakra UI",
      "State Management: Redux, Toolkit (RTK Query), React Query",
      "Data Visualization: ECharts, ApexCharts",
      "Backend Development: Node.js, Express.js",
      "RESTful API Development",
      "Authentication & Authorization: JWT, OAuth",
      "Database Management: MongoDB, PostgreSQL, MySQL",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Technical Research", percentage: 95 },
      { name: "Product Research", percentage: 90 },
      { name: "Innovation & Development", percentage: 85 },
      { name: "Software Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech in Computer Engineering",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "2020-2025",
      },
    ],
  },

  {
    id: 6,
    name: "Jewoola Favour",
    role: "Software Engineer (Mobile)",
    intro: "📍Mobile App Developer @ Cephas 📍 Working on StudyPadi 📍",
    yearsExperience: "6",
    projectsCompleted: "9",
    image: "favour.jpg",
    bio: `Favour is a Mobile App Developer at Cephas ICT Hub and the founder of Studypadi.  

As an intern, Favour is responsible for developing innovative mobile applications that enhance user experience and engagement. He has a proven track record of creating seamless and efficient applications using React Native and has a strong background in backend development with Node.js, MongoDB, and Express.  

Favour is the driving force behind Studypadi, an educational platform that provides students with access to free CBT and past questions. Originally launched as LauHub and now available on the web with over 800+ users, Studypadi features a leaderboard to encourage healthy competition among students.  

In addition to his technical skills, Favour is passionate about mentoring junior developers and helping them achieve their career goals.  

He is currently a Computer Science graduate at Ladoke Akintola University of Technology, where he expand his knowledge and skills in software development.  

As the Library Unit Coordinator of his student church, Favour is also actively engaged in community service and support.`,

    skills: [
      "Mobile Development: React Native, Expo",
      "State Management (Redux, Context API)",
      " Backend & Databases: Node.js, Express, MongoDB, Firebase, SQL+",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Technical Research", percentage: 95 },
      { name: "Product Research", percentage: 90 },
      { name: "Innovation & Development", percentage: 85 },
      { name: "Software Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech in Computer Science",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "2020-2025",
      },
    ],
  },

  {
    id: 7,
    name: "Oderinde Elisha",
    role: "Software Engineer (Mobile)",
    intro: "Mobile Engineer || Building scalable and innovative solutions",
    yearsExperience: "6",
    projectsCompleted: "12",
    image: "elishaa.jpg",
    bio: `Elisha is recognized as a creative and passion-driven mobile engineer with a strong background in chemical engineering. Scalable cross-platform mobile applications are built by him to help businesses and startups achieve their goals.

A deep commitment to problem-solving, innovation, and maintaining the highest industry standards is demonstrated by him, with a strategic approach applied to every project—from ideation to production.

Expertise in React Native, React.js, JavaScript, TypeScript, Dart, Flutter, Firebase, MongoDB, and Node.js is possessed by him, enabling high-performance applications to be crafted that deliver exceptional user experiences.

Beyond mobile development, his passion for graphic design enhances the creation of visually appealing interfaces in which functionality and aesthetics are seamlessly integrated.

Collaboration is welcomed by him to explore opportunities for building impactful digital solutions.`,

    skills: [
      "Node.js",
      "MongoDB",
      "AWS",
      "IT infrastructure design",
      "Javascript",
      "MATLAB",
      "React.js ",
      "Data analysis",
      "iOS Development",
      "Adobe Photoshop",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "Diploma, Computer Software Engineering",
        institution: "AltSchool Africa",
      },
      {
        degree: "B-Tech Computer Science Engineering ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
      },
      {
        degree: "Dart & Flutter | The Complete Flutter Development Course",
        institution: "Udemy",
      },
    ],
  },

  {
    id: 8,
    name: "Temiloluwa Paul",
    role: "Software & DevOps Engineer",
    intro: "Fullstack Software Developer | Agronomis",
    yearsExperience: "6",
    projectsCompleted: "13",
    image: "paul.jpg",
    bio: `Paul is recognized as a seasoned Fullstack Developer with a robust background in crafting dynamic web solutions. Proficiency in various programming languages and technologies has been demonstrated by him, allowing diverse projects to be navigated with finesse.

A pivotal role has been played by him in the development of Learning Management Systems, where user-centric design and functionality have been enhanced to improve the overall learning experience.

In the realm of logistics, APIs have been seamlessly integrated by him to optimize operational workflows, ensuring efficient communication and data exchange.

Involvement in Car Licensing platforms has honed his ability to navigate regulatory landscapes, ensuring compliance and reliability.

Beyond functionality, a keen eye for design has been applied by him in designing and implementing visually appealing landing pages that captivate and engage users.

The intersection of technical prowess and design sensibility has been established as a cornerstone of his career. Challenges have been embraced by him as opportunities to learn and innovate, reflecting his passion for pushing the boundaries of web development.

Collaborative endeavors are welcomed by him, and dynamic environments are leveraged to drive impactful results.

Connections are encouraged by him to explore exciting possibilities at the intersection of technology and creativity.`,

    skills: [
      "Git",
      " GitHub",
      "Web Application Development",
      "Web Interface Design",
      "React.js",
      "Tailwind CSS",
      "Astro.js",
      "Node.js",
      "Express.js",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech Crop Production and Soil Science ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2021- June 2025",
      },

      {
        degree: "Angular & NEXT Js",
        institution: "Sololearn",
      },
    ],
  },

  {
    id: 9,
    name: "Emurotu Paul",
    role: "Data Engineer",
    intro: "Data Scientist",
    yearsExperience: "8",
    projectsCompleted: "15",
    image: "emurotu.jpg",
    bio: `Driven by excellence and fueled by innovation, Paul has been recognized as a passionate Data Scientist with over 5 years of experience in applying Machine Learning, NLP, and Graph AI to solve real-world problems across the finance, technology, and consulting sectors.  
Specialization has been demonstrated by him in building robust, production-grade models — from fraud detection engines that were developed to reduce financial risk, to recommendation systems and deep learning solutions that have been implemented to drive user engagement and efficiency. His toolbelt has included Python, SQL, TensorFlow, PyTorch, and cloud platforms such as AWS and GCP. Beyond the code, he has been regarded as a people person, collaborative by nature, and deeply committed to ensuring that organizations extract value from data in ways that are ethical, scalable, and impactful.  

He has had the privilege of working with incredible teams to:  
• Achieve an increase in fraud detection accuracy by over 30% through the use of machine learning models  
• Deliver improvements in operational efficiency by 15–25% through process-driven analytics and strong automation knowledge  
• Provide training and mentorship to aspiring data professionals, enabling talent growth while advancing business goals  

Whether leading a data project, mentoring junior analysts, or presenting to stakeholders, energy, empathy, and an obsession with delivering high-quality outcomes have consistently been brought by Paul. If data products or teams aiming for impact are being built, he welcomes the opportunity to connect.`,

    skills: [
      "Data Segmentation",
      " Reporting & Analysis",
      " Organization Growth",
      "Data Analytics",
      "Machine Learning Algorithms ",
      "Risk Governance",
      "Data Mining",
      "Database Management Google Cloud Platform System",

      "Exploratory Data Analysis",
      "Data Administration ",
      "SQL",
      "Data Modeling ",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech Chemical Engineering ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Nov 2019-Mar 2024",
      },
    ],
  },

  {
    id: 10,
    name: "Ademola Abdullahi",
    role: "Software Engineer (Full stack)",
    intro:
      "[Full-Stack Web Developer] | [Node.js] | [React.js] | [JavaScript] | [TypeScript] | [Redux] | [Redux Toolkit] | [Zustand] | [Tailwind CSS] | [CSS] |[HTML] | [Crafting Interactive User Experience].",
    yearsExperience: "6",
    projectsCompleted: "9",
    image: "abdullahi.jpg",
    bio: `Ademola Abdullahi is a Front End Web Developer with a passion for crafting interactive user experiences.

He specialize in building dynamic and responsive web applications using modern technologies, including:

  • React.js: Developing complex, state-driven user interfaces
  • Redux Toolkit: Managing application state efficiently and predictably
  • JavaScript: Writing clean, efficient, and maintainable code
  • Tailwind CSS: Utilizing utility-first CSS frameworks for fast and scalable styling
  • CSS/HTML: Creating visually appealing and accessible web pages

With a focus on user-centric design, He excel in environments where he can contribute to creating seamless and engaging digital experiences.

Whether working independently or as part of a collaborative team, He is dedicated to delivering high-quality results and continuously improving my skill set.

Let’s connect and explore how we can collaborate to build impactful digital solutions.`,

    skills: [
      "Programming Languages: JavaScript, TypeScript",
      " Frameworks & Libraries: React Native, ReactJS, Next.js",
      "State Management: Redux, Context API",
      "API Integration: REST APIs, Firebase, Paystack",
      "Version Control: Git, GitHub",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Front-End Development ", percentage: 95 },
      { name: "React.js", percentage: 90 },
      { name: "JavaScript", percentage: 85 },
      { name: "Responsive Web Design", percentage: 88 },
      { name: "Redux Redux-toolkit", percentage: 89 },
    ],
    education: [
      {
        degree: "B.tech Computer Science ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "2019 - 2024",
      },
    ],
  },
  {
    id: 11,
    name: "Mercy Arawole",
    role: "Software Engineer (Full stack)",
    intro: "Computer Science | Software Developer at Cephas ICT Hub",
    yearsExperience: "6",
    projectsCompleted: "14",
    image: "mercy.jpg",
    bio: `Mercy is recognized as a full-stack developer with a strong passion for backend development. Problems are solved by her with software, and ideas are transformed into practical, efficient solutions. Coding has been regarded by her as more than just a career—it is consistently enjoyed and improvement is continuously pursued.

A deep interest in artificial intelligence is held by her, along with its potential to transform the way software is built. The integration of AI into applications is a goal she pursues to create smarter and more innovative systems capable of making a real impact.

With a background in computer science, a strong foundation in programming and software development has been acquired by her. Experience has been gained with tools such as Node.js, NestJS, React, MongoDB, and Tailwind CSS, and continual learning is actively sought.

Ultimately, growth as a backend developer in the AI space is aimed for by her, with technologies being built to solve real-world challenges.`,

    skills: [
      "Backend: Node.js, Express.js, MongoDB, TypeScript, NestJS, Swagger, git, Postman.",
      "Frontend: React.js, Tailwind CSS, Bootstrap, Tanstack query, Redux Toolkit Query.",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      // {
      //   degree: "Google AI Essentials",
      //   institution: "Google",
      //   period: "Feb 2023-Jan 2024",
      // },
      {
        degree: "B-Tech Computer Science ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Oct 2018 -Feb 2024",
      },
      {
        degree: "React - The Complete Guide 2024 (incl. Next.js, Redux)",
        institution: "Academind",
        // period: "Feb 2024",
      },
    ],
  },

  {
    id: 12,
    name: "Deborah Ayoola",
    role: "Cybersecurity Analyst",
    intro:
      "SOC Analyst: SIEM, EDR and SOAR || UI Designer || UX Researcher || Product Manager || McKinsey Forward Scholar '24 || WTF C'24 || Community Development || I4GCybersecurity C'23 || I write Cybersecurity Articles",
    yearsExperience: "6",
    projectsCompleted: "13",
    image: "ayoola.jpg",
    bio: `Debbie A. AYOOLA is recognized as a UI/UX Designer and Cybersecurity Analyst. User-centered experiences have been crafted by her, and digital systems have been secured to empower individuals and communities.

With over years in UI/UX design, intuitive and accessible interfaces have been developed to promote digital inclusion. In cybersecurity, sensitive information has been protected and threats mitigated. Over three years in community development, sustainable impacts have been driven, and social initiatives have been advanced.

Expertise is held in crafting engaging interfaces, securing digital systems, and fostering collaborative community projects. Opportunities for collaboration are welcomed by her to harness technology for meaningful and sustainable change.`,

    skills: [
      "Malware Analysis",
      " SOC",
      "IBM QRadar ",
      "Trend Micro",
      "Sentinel One",
      "Carbon Black",
      "Penetration Testing",
      "Product Design: Interaction Design, Visual Design, Branding, sketching",
      "prototyping",
      "figma",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech Computer Engineering ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "2013-2019",
      },
      // {
      //   degree: "Cybersecurity",
      //   institution: "Women Techster Fellowship",
      //   period: "Oct 2023",
      // },

      // {
      //   degree: "Web and Mobile Design | UI/UX Design",
      //   institution: "Zero to Mastery Academy",
      //   period: "July 2022 - Sept 2022",
      // },

      // {
      //   degree: "Cybersecurity Job Simulation",
      //   institution: "Forage",
      //   period: "April 2024",
      // },
      // {
      //   degree: "Cybersecurity Validation Analyst",
      //   institution: "Virtually Testing Foundation",
      //   period: "April 2024",
      // },
      // {
      //   degree: "Foundations of Cybersecurity",
      //   institution: "Virtually Testing Foundation",
      //   period: "April 2024",
      // },
    ],
  },
  {
    id: 13,
    name: "Oluwole Odunayo",
    role: "Business Growth Strategist ",
    intro:
      "Business Development and growth | Marketing and innovation | Strategic Branding | Empowering Businesses to Thrive | Community Development",
    yearsExperience: "6",
    projectsCompleted: "8",
    image: "odunayo.jpg",
    bio: `Odunayo is recognized for over four years of experience in branding and marketing, during which substantial business growth has been driven, brand visibility enhanced, and marketing objectives consistently exceeded.

The marketing team at Cephas ICT HUB is currently led by her, where innovative strategies are overseen and implemented to propel the business forward. She is also the Founder of TIROSH, a marketing and branding agency through which businesses are helped to thrive in competitive markets.

Her marketing journey was begun as an intern at Cephas ICT HUB, where a strong foundation was established. Further skills were developed during her tenure as a Marketing and Research Intern at NITEON.

A Marketing background from Ladoke Akintola University of Technology, combined with an MBA, is held by her, providing a unique blend of theory and hands-on expertise. Strategic approaches are applied by her to challenges, utilizing in-depth market insight and data-driven decision-making skills. Impactful marketing strategies are leveraged by her to drive growth and achieve measurable results.

Empowerment of businesses to excel in competitive environments is prioritized by her, and commitment is shown to helping them reach their growth goals. Opportunities for collaboration are welcomed by her to advance business success.`,

    skills: [
      "SEO & Paid Advertising",
      " Email Marketing Campaigns",
      "Marketing Automation",
      "CRM Tools",
      "Business Writing",
      "Proposal Writing and Presentation",
      " Video Production & Editing",
      "Client Acquisition & Retention",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "Master of Business Administration, Marketing ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Aug 2023 - Oct 2024",
      },

      {
        degree: "B-Tech, Marketing ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2017-May 2023",
      },
    ],
  },
  {
    id: 14,
    name: "Odewumi Esther",
    role: "Business Growth Strategist",
    intro:
      "Financial Analyst | Data analyst | Finance Manager | Training Manager | Business Strategist | Financial Development | Community Development Advocate",
    yearsExperience: "6",
    projectsCompleted: "5",
    image: "esther.jpg",
    bio: `Esther is recognized as a results-driven Finance Manager and Training Manager at Cephas ICT Hub, where financial operations and curriculum development are overseen to drive business growth and technical empowerment.

A strong foundation in financial reporting, strategic management, and business development is held by her, and sustainable financial strategies and innovative training programs have been created by her to empower individuals and organizations.

Beyond her professional roles, active contributions have been made by her as a member of the LiteArt Foundation for Community Development, supporting initiatives that foster growth and social impact.

Continuous efforts are undertaken by her as an upcoming business strategist and financial development professional to integrate financial intelligence with business sustainability.`,

    skills: [
      "Accounting Standards",
      " Microsoft Office Suite",
      "financial analysis",
      "budgeting",
      "variance analysis",
      "Data Science",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree:
          "B.Tech. in Management and Accounting, Ladoke Akintola University of Technology Ogbomosho, Oyo State",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2017-May 2023",
      },
    ],
  },
  {
    id: 15,
    name: "Okunola Esther",
    role: "People Operations Manager",
    intro: "Fullstack Software Developer | Agronomis",
    yearsExperience: "6",
    projectsCompleted: "6",
    image: "estherokunola.jpg",
    bio: `Esther is a seasoned human resources remote administrative assistant professional. 
She specializes in driving exceptional HR operations, helping busy CEOs, professionals, and coaches streamline 
their day-to-day operations, and providing top-notch support to clients and organizations. Her expertise includes 
ensuring seamless operations, coordinating virtual events, and managing data with precision. 

Currently, Esther serves as an HR Generalist at Cephas ICT Hub, where she applies her knowledge of human 
behavior and performance to drive HR operations, talent management, and employee engagement. Her experience in HR 
has equipped her with a solid understanding of policy development, recruitment, and employee relations. 

What sets Esther apart is her passion for empowering individuals and communities. As an aspiring Growth Mindsets & 
Economic Empowerment Strategist, she is dedicated to harnessing the power of human potential to drive socio-economic 
growth. Her ultimate goal is to create sustainable impact by helping individuals develop the skills, mindset, and 
resources needed to achieve economic stability, mobility, and prosperity. 

`,

    skills: [
      "Recruitment and talent acquisition",
      " Employee relations and conflict resolution",
      "Training and development,",
      "Employee onboarding and orientation",
      "Compensation and benefits administration",
      "Performance management and evaluation",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
      // { name: "French", level: "Intermediate" },
      // { name: "German", level: "Basic" },
    ],
    technicalSkills: [
      { name: "Talent Development & Acquisition", percentage: 95 },
      { name: "Team Building & Collaboration", percentage: 90 },
      { name: "Recruitment & Selection", percentage: 85 },
      { name: "Problem solving", percentage: 88 },
      { name: "Communication", percentage: 87 },
    ],
    education: [
      {
        degree: "BSC Medical Physiology ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2017-May 2023",
      },
    ],
  },
  {
    id: 16,
    name: "Olawumi Titilayo",
    role: "Data Scientist",
    intro: "Fullstack Software Developer | Agronomis",
    yearsExperience: "6",
    projectsCompleted: "8",
    image: "titilayo.jpg",
    bio: "Leah is a passionate data scientist/analyst at Cephas ICT HUB with experience in Python, Power Bi, Excel etc, Leah is also a tutor in cephas ICT Hub, with experiences in teaching and mentoring individual of different ages and background on topics related to Data analysis, Python, Data science.My passion for data science has taken me through various internship as a data scientist in reputable organization - Techyjaunt, Cephas Ict Hub, CodSoft. These experience has shaped her skills in data analysis and visualization, statistical analysis and modeling, machine learning implementation. she has a Bachelor's of technology degree in Science Laboratory Technology (Microbiology) at Ladoke Akintola University of Technology, Oyo state, Nigeria and Data scientist from Codsoft",
    skills: [
      "Python,",
      " Machine Learning",
      "Power BI,",
      "SQL",
      "SPSS",
      " Excel",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech  Science Laboratory Technology (Microbiology) ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2017-May 2023",
      },
    ],
  },
  {
    id: 17,
    name: "Adisa Temitope",
    role: "Product Designer",
    intro: "Product designer (UI/UX), Graphic designer",
    yearsExperience: "6",
    projectsCompleted: "8",
    image: "temitope.jpg",
    bio: `Temitope is a product designer at Cephas ICT Hub. As a product Temitope creates user-centric digital experiences that drive business growth and enhance customer satisfaction.
She is marked by a deep commitment to understanding user needs, translating them into innovative solutions, and ensuring that products are not only aesthetically pleasing but also functional and accessible.
Temitope is a student at Ladoke University of Technology, where she is currently studying computer science.`,
    skills: [
      "User Research,",
      " Wireframing & Prototyping",
      "Visual Design",
      "Interaction Design",
      "UI/UX Design",
      "Design Systems",
      " Collaboration",
      "Usability Testing",
      "Responsive Design",
      "Typography & Color Theory",
      "Creative Problem Solving",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech Computer Science Laboratory Technology ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2017-May 2023",
      },
    ],
  },
  {
    id: 18,
    name: "Ajao Joshua",
    role: "Data Scientist",
    intro: "Fullstack Software Developer | Agronomis",
    yearsExperience: "6",
    projectsCompleted: "15",
    image: "joshua.jpg",
    bio: "I am a passionate and ambitious individual with a strong drive for research, development, organization, administration, and building meaningful relationships. Thriving in competitive environments, I embrace challenges with enthusiasm My background includes a deep understanding of the strategic and international dimensions of research and development, along with the ability to critically evaluate models and concepts and apply them in practical settings. I consider myself Naturally Endowed with Research and Development (NERD) One of my key strengths is my ability to navigate diverse perspectives among individuals, fostering growth and learning in multicultural environments. My skill set includes exceptional time management, a strong team spirit, effective communication, meticulous attention to detail, and an unwavering commitment to excellence. Passion drives me, and I have a profound love for Mathematics, Chemistry, Biotechnology, Material Science and Nanotechnology. The amalgamation of Physics, Chemistry, Biology, and Mathematics fascinates me, and I am also deeply interested in Machine Learning and Teaching.Whether I'm in the laboratory or engrossed in research papers on my PC, I find joy in exploring the frontiers of knowledge. I hope this glimpse into my interests and qualities gives you an understanding of who I am. Thank you.",
    skills: [
      "Machine Learning",
      " MATLAB",
      "Data Science",
      "Web Design",
      "Web Development",
      "Microsoft Office Suites",
      "Node.js",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
      // { name: "French", level: "Intermediate" },
      // { name: "German", level: "Basic" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech Chemical Engineering ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2017-May 2023",
      },
      {
        degree: "Msc Chemical Engineering",
        institution: "Auburn University, USA",
        // period: "Feb 2024",
      },
    ],

    // socialLinks: [
    //   {
    //     platform: "LinkedIn",
    //     url: "https://www.linkedin.com/in/joshua-ajao-2281b9212/",
    //     image: require("../src/assets/img/UI/linkedin.png"), // Image file for transparent icon
    //   },
    //   {
    //     platform: "Twitter",
    //     url: "https://twitter.com/odunayo",
    //     image: X, // Image file for transparent icon
    //   },
    //   {
    //     platform: "Reddit",
    //     url: "https://reddit.com/u/odunayo",
    //     image: Dribble, // Image file for transparent icon
    //   },
    //   {
    //     platform: "Behance",
    //     url: "https://behance.net/odunayo",
    //     image: Be, // Image file for transparent icon
    //   },
    // ],
  },
  {
    id: 19,
    name: "Akintunde Timileyin",
    role: "Product Designer",
    intro: "Product Designer at Cephas ICT Hub",
    yearsExperience: "3",
    projectsCompleted: "8",
    image: "timileyin.jpg",
    bio: `Michael is recognized for dedication to pushing the boundaries of design excellence and creating positive impact through thoughtful and impactful design.

Over three years of experience in graphic design have been gained by him, during which visually appealing and effective design solutions have been developed. Expertise is held in Adobe Photoshop, Illustrator, and Figma, with a strong foundation in typography, color theory, and layout design.

Collaborative projects have been successfully executed by him with cross-functional teams, including branding, marketing collateral, app design, and social media graphics. Multiple projects have been managed simultaneously by him while ensuring tight deadlines are met.

Commitment is shown by him to staying updated with the latest design trends and technologies, enabling innovative and effective visual content to be delivered consistently.`,

    skills: [
      "User Research",
      " Wireframing & Prototyping",
      "Visual Design",
      "Interaction Design",
      "User Experience (UX), Design",
      "UI Design",
      "Design Systems",
      "Accessibility & Collaboration",
      "Design Thinking",
      "Creative Problem Solving",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech Mechanical Engineering ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2019-May 2024",
      },
    ],
  },

  {
    id: 20,
    name: "Adebiyi Segun",
    role: "IOT Engineer",
    intro:
      "Electronics and Electrical Engineer: Driving Innovation in IoT and Embedded Systems",
    yearsExperience: "6",
    projectsCompleted: "9",
    image: "segun.jpg",
    bio: `Segun is recognized as an IoT Engineer, specializing in leveraging a background in Electronics and Electrical Engineering to develop innovative solutions that bridge the physical and digital worlds.

A solid foundation in electronics, embedded systems, and microcontroller programming has been built by him, with languages such as C, C++, and Python being applied to construct and enhance IoT systems.

A B.Tech in Electronics and Electrical Engineering has been earned by him, providing a deep understanding of both theoretical and practical aspects of the field. Advancement of technology through smart, connected devices is actively pursued, with opportunities to drive innovation in the IoT space continuously sought.

Professional connections and collaborations with organizations focused on pioneering technological and IoT advancements are welcomed by him to shape the future of interconnected systems.`,

    skills: [
      "programming Languages (C, C++, Python)MERN stack",
      " embedded systems development",
      "IoT protocols",
      "(MQTT, CoAP)",
      "sensor integration",
      "cloud platforms (AWS IoT, Azure)",
      "network communication",
      "cybersecurity",
      "data analytics",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech Electronics and Electrical Engineering ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "2015-2020",
      },
    ],
  },
  {
    id: 21,
    name: "Taiwo Mary",
    role: "Digital Marketer",
    intro:
      "Digital Marketer | Content creator | Social Media Manager | Product Manager",
    yearsExperience: "6",
    projectsCompleted: "8",
    image: "mary.jpg",
    bio: `Mary is recognized as a creative and strategic professional, skilled in digital marketing, graphic design, video editing, product management, and content creation. Growth and engagement have been driven by her through innovative solutions.

Campaigns have been developed and executed by her to enhance brand visibility and drive conversions. Engaging visual and written content has been created by her to resonate with target audiences, boost brand visibility, drive conversions, and leave lasting impressions.

A strategic mindset has been applied by her through experience in product management, enabling projects to be managed efficiently from concept to completion. Effective collaboration with cross-functional teams has also been demonstrated by her.`,

    skills: [
      "SEO & Paid Advertising",
      " Email Marketing Campaigns",
      "Content Management Systems",
      "Social Media Marketing",
      "Content Strategy",
      "Storytelling ",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "BSC Computer Science ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2017-May 2023",
      },
    ],

    socialLinks: [
      {
        platform: "LinkedIn",
        url: "https://www.linkedin.com/in/taiwomary/",
        image: require("../src/assets/img/UI/linkedin.png"), // Image file for transparent icon
      },
      {
        platform: "Twitter",
        url: "https://twitter.com/odunayo",
        image: X, // Image file for transparent icon
      },
      {
        platform: "Reddit",
        url: "https://reddit.com/u/odunayo",
        image: Dribble, // Image file for transparent icon
      },
      {
        platform: "Behance",
        url: "https://behance.net/odunayo",
        image: Be, // Image file for transparent icon
      },
    ],
  },
  {
    id: 22,
    name: "Oyeyemi Feranmi",
    role: "Product Manager",
    intro: "Digital Marketer | Product manager @Cephas ICT HUB",
    yearsExperience: "6",
    projectsCompleted: "8",
    image: "feranmi.jpg",
    bio: "Feranmi is recognized as a skilled Digital Marketer and Product Manager, known for driving impactful strategies and overseeing successful product lifecycles. Her expertise has been applied to developing innovative solutions, enhancing brand visibility, and ensuring seamless user experiences. She is valued for her ability to align marketing efforts with business objectives, resulting in measurable growth and engagement.",
    skills: [
      "Microsoft Suite",
      " Graphic design",
      "Social Media Marketing",
      "Content Strategy",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech Marketing ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2017-May 2023",
      },
    ],
  },
  {
    id: 23,
    name: "Aremu Moses",
    role: "Software Engineer (Web)",
    intro:
      "React Native Developer | Cross-Platform Mobile Engineer | Firebase | Redux | Building Real-Time & Scalable Mobile Apps",
    yearsExperience: "6",
    projectsCompleted: "9",
    image: "moses.jpg",
    bio: `Moses is recognized as a React Native Developer with over five years of experience in designing, building, and deploying mobile applications for iOS and Android.

Cross-platform mobile apps have been built by him using React Native, JavaScript (ES6+), Redux, and Firebase. Intuitive and high-performance mobile experiences have been delivered by him to ensure scalability. Several production apps, including Kobosquare, Durable Telecom, and VVGroup, have been launched by him on the Play Store and App Store, featuring robust functionalities such as real-time payments, push notifications, and peer-to-peer transactions.

Skills are held by him in React Native, Redux, Firebase (Auth, Firestore, Notifications), REST APIs, and Expo. Clean code, reusable components, and performance optimization are emphasized in his work. Agile collaboration with designers, backend engineers, and product teams has been consistently demonstrated by him.

Opportunities for connection and collaboration are welcomed by him to contribute, grow, and build meaningful mobile solutions.`,

    skills: [
      "Programming Languages: JavaScript, TypeScript, HTML, CSS",
      " Frameworks & Libraries: React Native, ReactJS, Next.js",
      "State Management: Redux, Context API, API Integration",
      "REST APIs, Firebase, Paystack",
      "Version Control: Git, GitHub",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "Mobile Application Development", percentage: 95 },
      { name: "Technical Support", percentage: 90 },
      { name: "iOS Development", percentage: 85 },
      { name: "Android Development", percentage: 88 },
    ],
    education: [
      {
        degree: "B-Tech Computer Engineering ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Nov 2019-Mar 2024",
      },
    ],
  },
  {
    id: 24,
    name: "Adekola Adekolapo",
    role: "Software Engineer (Full stack)",
    intro: "Software Developer 💻 | Creative Designer 🎨 | Technical Writer ✍️",
    yearsExperience: "6",
    projectsCompleted: "8",
    image: "kolapo.jpg",
    bio: `Adekolapo is a Frontend Developer and Instructor currently interning at Cephas ICT Hub. 
In this role, Adekolapo has contributed to three projects and trained over 80 students in frontend technologies, 
including both JavaScript and general web development skills. 

Proficient in HTML, CSS, Tailwind CSS, Bootstrap, SCSS, JavaScript, React, React Query, and with some experience in Node.js, 
Adekolapo brings a strong technical foundation to every project. 

In addition to development, Adekolapo has a background in graphic design and technical writing, 
with articles published on Medium and Hashnode and a YouTube tutorial @Dev Kola. 

Adekolapo is also an active volunteer, having supported numerous tech and non-tech events, 
and has spoken at two conferences/seminars, sharing insights and expertise with a wider audience. 

Currently pursuing a degree in Information Systems at Ladoke Akintola University of Technology, 
Adekolapo holds certifications in React from Andela, Tech Educator from Rubik’s Technologies, 
FreeCodeCamp Responsive Web Design, and Git Certificate from Udemy. 

With a professional goal to become a standout software engineer, Adekolapo focuses on leveraging 
technological innovation to create sustainable projects. Dedicated to contributing to impactful projects 
and advancing the tech industry, Adekolapo is committed to delivering creative and effective solutions.`,

    skills: [
      "Node.js",
      "JavaScript",
      " Express",
      "React",
      "Tailwindcss,",
      "Sass",
      "Bootstrap",
    ],
    languages: [
      { name: "English", level: "Advanced" },
      { name: "Yoruba", level: "Native" },
    ],
    technicalSkills: [
      { name: "JavaScript", percentage: 95 },
      { name: "Node.js", percentage: 90 },
      { name: " Express", percentage: 85 },
      { name: "React", percentage: 88 },
      { name: "Tailwindcss,", percentage: 100 },
    ],
    education: [
      {
        degree: "B.tech Information System Engineer ",
        institution: "Ladoke Akintola University of Technology, LAUTECH",
        // period: "Jan 2022 -sept 2027",
      },
    ],
  },
];
export default teamProfile;
